import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
//Img
import quoteImg from "../../../img/qutation.png";
import avatarImg from "../../../img/testi_avatar.png"
//CSS
import './style.css';
//
export default function Testimonials(props){
    return(
        <section id={props.id} className="testimonial-area testimonial-p">
            <Container className="container">
                <Row className="row">    
                    <Col className="col-lg-6">
                            <div className="section-title center-align">                              
                            <h2>{props.title}</h2>
                            <p>{props.text}</p>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="testimonial-active slick-initialized slick-slider">
                            <div className="slick-list draggable">
                                <div className="slick-track">
                                    {props.testimonialsList.map((item,i)=>
                                        <Col xl={4} className="slick-slide slick-cloned" key={i}>
                                            <div className="single-testimonial">
                                                <div className="testi-author text-left">
                                                    <img src={avatarImg} alt="img" style={{display: 'none'}}/>
                                                    <div className="ta-info">
                                                        <h6>{item.name}</h6>
                                                        <span>{item.where}</span>
                                                    </div>
                                                </div>
                                                <div className="qutation">
                                                    <img src={quoteImg} alt="qutation.png"/>
                                                </div>
                                                <p>{item.say}</p>
                                            </div>
                                        </Col>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}